import Axios from "axios";

let listeners = [];

function initCollapsibleSidebar() {
	try {
		const collapseSidebarButton = document.querySelector('.collapse-sidebar-button');
		const collapseSidebarButtonIcon = collapseSidebarButton.querySelector('i');
		const sideBar = document.querySelector('.sidebar');
		const mainPanel = document.querySelector('.main-panel');
		const navbarBrandWrapper = document.querySelector('.navbar-brand-wrapper-custom')
		const navbarMenuWrapper = document.querySelector('.navbar-menu-wrapper-custom')

		collapseSidebarButton.addEventListener('click', toggleCollapsedSidebar)


		/** Methods */

		function toggleCollapsedSidebar() {
			if (sideBar.classList.contains('collapsed')) {
				sideBar.classList.remove('collapsed');
				mainPanel.classList.remove('sidebar-collapsed');
				navbarBrandWrapper.classList.remove('sidebar-collapsed');
				navbarMenuWrapper.classList.remove('sidebar-collapsed');

				collapseSidebarButton.title = 'Hide Sidebar';

				collapseSidebarButtonIcon.classList.add('mdi-arrow-collapse-left')
				collapseSidebarButtonIcon.classList.remove('mdi-arrow-collapse-right')
			} else {
				sideBar.classList.add('collapsed');
				mainPanel.classList.add('sidebar-collapsed');
				navbarBrandWrapper.classList.add('sidebar-collapsed');
				navbarMenuWrapper.classList.add('sidebar-collapsed');

				collapseSidebarButton.title = 'Show Sidebar';

				collapseSidebarButtonIcon.classList.remove('mdi-arrow-collapse-left')
				collapseSidebarButtonIcon.classList.add('mdi-arrow-collapse-right')
			}

			try {
				// Update server side for future renders
				Axios.post(window['ui-setting.update'], {
					key: window['ui-setting-keys.sidebar-collapsed-status'],
					value: sideBar.classList.contains('collapsed').toString(),
				})
					.then()
					.catch();
			} catch (e) {
				console.error('Error updating server side UI setting');
				console.error(e);
			}

			listeners.forEach(callback => {
				try {
					callback(sideBar.classList.contains('collapsed'));
				} catch (e) {
					console.error('Error executing collapsed sidebar callback');
					console.error(e);
				}
			})
		}

	} catch (e) {
		console.error('Error Initializing Collapsible Sidebar')
		console.error(e);
	}
}

/**
 * Adds a listener for collapse sidebar events, the callback
 * receives the new collapsed status
 *
 * @param callback
 */
function addSidebarCollapseToggleListener(callback) {
	listeners.push(callback)
}

export {initCollapsibleSidebar, addSidebarCollapseToggleListener};
